import React, { Component } from "react";
import { LOGOUT_ICON, UPLOAD_ICON, PENCIL } from "../../Constants/SrcImages";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { COLUMNS_ADMIN_ANNOUNCEMENT } from "../../Constants/DatatableColumns";
import { Row, Col, Container, Button, Label } from "reactstrap";
import { AnuncioModal, ChangeImageAnnouncement } from "./../../Constants/Modal";
import {
  getAnnouncement,
  postAnnouncement,
  putStatusAnnouncement,
  urlUploadAnnouncement,
  urlHttpPostAnnouncement,
  putDescAdvert,
} from "../../Constants/Services";
import { IAnnouncement } from "./../../Constants/Interfaces";
import { ImageViewerAnnouncement,validateTokenStorage } from "./../../Constants/Util";
import moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IGradesState {
  dataAnnouncement: IAnnouncement[];
  formAnnouncement: IAnnouncement;
  loading: boolean;
  isOpenModalAnnouncement: boolean;
  isOpenModalImageAnnouncement: boolean;
  isOpenModalEditAnnouncement: boolean;
  msg_error: string;
}

class Announcement extends Component<RouteComponentProps<{}>, IGradesState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataAnnouncement: [],
      formAnnouncement: {
        ad_id: "",
        ad_img: "",
        ad_desc: "",
        ad_date: "",
      },
      loading: false,
      isOpenModalAnnouncement: false,
      isOpenModalEditAnnouncement: false,
      isOpenModalImageAnnouncement: false,
      msg_error: "",
    };

    this.fetchAnnouncement = this.fetchAnnouncement.bind(this);
    this.handlerPostAnnouncement = this.handlerPostAnnouncement.bind(this);
    this.putStatus = this.putStatus.bind(this);
    this.onChangeAnnouncement = this.onChangeAnnouncement.bind(this);
    this.handlerModalAddAnnouncement = this.handlerModalAddAnnouncement.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handlerDataDelete = this.handlerDataDelete.bind(this);
    this.handleOptionsAnuncio = this.handleOptionsAnuncio.bind(this);
    this.handlerDataUploadImage = this.handlerDataUploadImage.bind(this);
    this.handlerModalCloseImageAnnouncement = this.handlerModalCloseImageAnnouncement.bind(this);
    this.handlerPutDescAdvert = this.handlerPutDescAdvert.bind(this);
    this.handlerModalEditAnnouncement = this.handlerModalEditAnnouncement.bind(this);
    this.handleEditAnuncio = this.handleEditAnuncio.bind(this);
    this.handlerSetAnuncio = this.handlerSetAnuncio.bind(this);
  }

  async fetchAnnouncement() {
    const response = await getAnnouncement();
    this.setState({
      dataAnnouncement: response,
      loading: false,
      msg_error: "",
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchAnnouncement();
  }

  handlerPutDescAdvert() {
    const props = this.state.formAnnouncement;
    if (props.ad_desc.length > 0) {
      const body = {
        ad_id: props.ad_id,
        ad_desc: props.ad_desc,
      };

      putDescAdvert(body);
      this.setState({ isOpenModalAnnouncement: false, isOpenModalEditAnnouncement: false, loading: true, msg_error: "" });

      setTimeout(() => {
        this.fetchAnnouncement();
      }, 1000);
    } else {
      this.setState({ msg_error: "Tienes el campo de anuncio vacio" });
    }
  }

  handlerPostAnnouncement() {
    const props = this.state.formAnnouncement;
    if (props.ad_desc.length > 0) {
      const body = {
        ad_desc: props.ad_desc,
        ad_date: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
      };

      postAnnouncement(body);
      this.setState({ isOpenModalAnnouncement: false, loading: true, msg_error: "" });

      setTimeout(() => {
        this.fetchAnnouncement();
      }, 1000);
    } else {
      this.setState({ msg_error: "Tienes el campo de anuncio vacio" });
    }
  }

  putStatus(ad_id: string) {
    const body = {
      ad_id,
    };

    putStatusAnnouncement(body);
    this.setState({ isOpenModalAnnouncement: false, loading: true, msg_error: "" });

    setTimeout(() => {
      this.fetchAnnouncement();
    }, 1000);
  }

  onChangeAnnouncement(e: any) {
    this.setState({
      formAnnouncement: {
        ...this.state.formAnnouncement,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
    });
  }

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchAnnouncement();
    }, 1000);
  }

  handlerModalAddAnnouncement() {
    this.setState((prevState) => ({
      isOpenModalAnnouncement: !prevState.isOpenModalAnnouncement,
      isOpenModalImageAnnouncement: false,
      isOpenModalEditAnnouncement: false,
      formAnnouncement: {
        ad_id: "",
        ad_img: "",
        ad_desc: "",
        ad_date: "",
      },
      msg_error: "",
    }));
  }

  handlerModalEditAnnouncement() {
    this.setState((prevState) => ({
      isOpenModalEditAnnouncement: !prevState.isOpenModalEditAnnouncement,
      isOpenModalAnnouncement: false,
      isOpenModalImageAnnouncement: false,
      formAnnouncement: {
        ad_id: "",
        ad_img: "",
        ad_desc: "",
        ad_date: "",
      },
      msg_error: "",
    }));
  }

  handlerModalCloseImageAnnouncement() {
    this.setState((prevState) => ({
      isOpenModalAnnouncement: false,
      isOpenModalImageAnnouncement: false,
    }));
    setTimeout(() => {
      this.fetchAnnouncement();
    }, 1000);
  }

  handlerModalImageAnnouncement(row: any) {
    this.setState((prevState) => ({
      isOpenModalAnnouncement: false,
      isOpenModalImageAnnouncement: true,
      formAnnouncement: row,
    }));
  }

  handlerDataDelete = (row: IAnnouncement) => {
    this.putStatus(row.ad_id);
  };

  handlerDataUploadImage = (row: IAnnouncement) => {
    this.putStatus(row.ad_id);
  };

  handlerSetAnuncio = (row: IAnnouncement) => {
    this.setState({
      isOpenModalEditAnnouncement: true,
      isOpenModalAnnouncement: false,
      isOpenModalImageAnnouncement: false,
      formAnnouncement: row,
    });
  };

  handleEditAnuncio(cell: number, row: IAnnouncement) {
    return (
      <div className="d-flex">
        <Label onClick={() => this.handlerSetAnuncio(row)}>{row.ad_id}</Label>
        <img className="img-status img-search" onClick={() => this.handlerSetAnuncio(row)} src={PENCIL} alt="" />
      </div>
    );
  }

  handleOptionsAnuncio(cell: number, row: IAnnouncement) {
    return (
      <div className="d-flex">
        <img className="img-status img-search mr-3" onClick={() => this.handlerModalImageAnnouncement(row)} src={UPLOAD_ICON} alt="" />
        <img className="img-status img-search" onClick={() => this.handlerDataDelete(row)} src={LOGOUT_ICON} alt="" />
      </div>
    );
  }

  handleImageAnuncio(cell: number, row: IAnnouncement) {
    return (
      <Row>
        <Col xs={12}>
          <ImageViewerAnnouncement ad_img={row.ad_img} />
        </Col>
      </Row>
    );
  }

  render() {
    const props = this.state;
    const urlImage = urlUploadAnnouncement + props.formAnnouncement.ad_img + ".png";
    return (
      <React.Fragment>
        {props.isOpenModalAnnouncement && (
          <AnuncioModal
            title="Agregar anuncio"
            data={props.formAnnouncement}
            isOpen={props.isOpenModalAnnouncement}
            toggle={this.handlerModalAddAnnouncement}
            toggleSave={this.handlerPostAnnouncement}
            onChange={this.onChangeAnnouncement}
            msg_error={props.msg_error}
          />
        )}

        {props.isOpenModalEditAnnouncement && (
          <AnuncioModal
            title="Editar anuncio"
            data={props.formAnnouncement}
            isOpen={props.isOpenModalEditAnnouncement}
            toggle={this.handlerModalEditAnnouncement}
            toggleSave={this.handlerPutDescAdvert}
            onChange={this.onChangeAnnouncement}
            msg_error={props.msg_error}
          />
        )}
        {props.isOpenModalImageAnnouncement && (
          <ChangeImageAnnouncement
            isOpen={props.isOpenModalImageAnnouncement}
            toggle={this.handlerModalCloseImageAnnouncement}
            IMG_AVATAR={urlImage}
            nameImg={props.formAnnouncement.ad_id}
            urlHttp={urlHttpPostAnnouncement}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <h3>Anuncios</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                  <Button color="success" onClick={() => this.handlerModalAddAnnouncement()}>
                    Agregar nuevo
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataAnnouncement}
                    columns={COLUMNS_ADMIN_ANNOUNCEMENT(this.handleOptionsAnuncio, this.handleImageAnuncio, this.handleEditAnuncio)}
                    keyProp="ad_id"
                    exportD={false}
                    searchs={true}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Announcement;
